export default {
  QUICK_FILTERS: {
    AWAITING_RESPONSE: 'Awaiting Response',
    ASSIGNED_DIRECTLY_TO_AGENT: 'Assigned directly to agent',
    ASSIGNED_TO_TEAM: 'Assigned to team',
    TEAM_ASSIGNED_AWAITING_AGENT: 'Team assigned with no agents assigned',
  },
};
